var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardHeart = function SvgCreditCardHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "credit_card_heart_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#credit_card_heart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-8 .325V6zm13.9 2.075q-.2 0-.375-.062a.9.9 0 0 1-.325-.213L14.4 17a1.9 1.9 0 0 1-.463-.7q-.137-.375-.137-.75 0-.8.575-1.425t1.475-.625q.7 0 1.1.325t.95.875q.5-.5.913-.85.412-.35 1.137-.35.925 0 1.488.637.562.638.562 1.438 0 .375-.15.75T21.4 17l-2.8 2.8q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063M4 8h16V6H4zm7.575 12H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 18V6q0-.824.587-1.412A1.93 1.93 0 0 1 4 4h16q.824 0 1.413.588Q22 5.175 22 6v5.325a7.3 7.3 0 0 0-1.913-.975A6.8 6.8 0 0 0 17.9 10q-1.425 0-2.687.537A7.2 7.2 0 0 0 13 12H4v6h6.975a7 7 0 0 0 .6 2"
  }))));
};
export default SvgCreditCardHeart;